export default "__VITE_ASSET__BsoRTcHQ__"